export const invoiceFees = [
    { id: 8192, name: "Yes" },
    { id: 8200, name: "No" }
];